var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.seeAllFeaturesCard},[_c('p',{class:_vm.$style.seeAllDescription},[_vm._v(" "+_vm._s(_vm.description)+" ")]),_c('FlatActionButton',{attrs:{"action":_vm.handleSeeAllButtonClick,"buttonClass":['btnDefault', _vm.$style.seeAllButton],"text":_vm.seeAllButtonText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }